// extracted by mini-css-extract-plugin
module.exports = {"PasswordForm":"PasswordForm_PasswordForm__tOSzg","ButtonLine":"PasswordForm_ButtonLine__AS2ov","information":"PasswordForm_information__U0_sx"};